import React from "react";
import { Link } from "react-router-dom";

const Navbar = ({ children }) => {
  return (
    <div className="">
      <div className="drawer drawer-end">
        <input id="my-drawer-4" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content flex flex-col">
          {/* Navbar */}
          <div className="w-full navbar">
            <div className="block lg:hidden flex-1 px-2 text-center font-bold text-2xl text-[#207561]">
              A<sup>2</sup>N
            </div>
            <div className="flex-none lg:hidden">
              <label htmlFor="my-drawer-4" className="btn btn-square btn-ghost">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  className="inline-block w-6 h-6 stroke-current"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  ></path>
                </svg>
              </label>
            </div>

            <div
              id="navbar-section"
              className="flex-none mx-auto hidden lg:block"
            >
              <ul className="menu menu-horizontal gap-5 font-medium text-lg text-gray-800">
                {/* Navbar menu content here */}

                <li>
                  <a href="/#aboutMe">About</a>
                </li>
                <li>
                  <a href="/#skills">Skills</a>
                </li>
                <li>
                  <a href="/#education">Education</a>
                </li>
                <li>
                  <Link
                    to="/"
                    href="https://devnoman-01.web.app/"
                    className="text-3xl font-light md:font-medium text-[#207561] gap-0"
                  >
                    A<sup>2</sup>N
                  </Link>
                </li>
                <li>
                  <a href="/#projects">Projects</a>
                </li>
                <li>
                  <a href="/#blogs">Blogs</a>
                </li>
                <li>
                  <a href="/#contact">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          {/* Page content here */}
          <div>{children}</div>
        </div>
        <div className="drawer-side">
          <label htmlFor="my-drawer-4" className="drawer-overlay"></label>
          <ul className="menu p-4 overflow-y-auto w-64 text-gray-800 font-medium bg-white">
            {/* Sidebar content here */}
            <li>
              <Link to="/" className="text-2xl text-[#207561] gap-0">
                A<sup>2</sup>N
              </Link>
            </li>
            <li>
              <a href="/#aboutMe">About</a>
            </li>
            <li>
              <a href="/#skills">Skills</a>
            </li>
            <li>
              <a href="/#education">Education</a>
            </li>
            <li>
              <a href="/#projects">Projects</a>
            </li>
            <li>
              <a href="/#blogs">Blogs</a>
            </li>
            <li>
              <a href="/#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
